// extracted by mini-css-extract-plugin
export default {"taegeukgi":"LoadingSpinner_taegeukgi__PAIXV","spin":"LoadingSpinner_spin__YPWy1"};